export enum MonitorPriceStatusEnum {
  Price_Within_Range = "Price_Within_Range",
  Price_Below_Range = "Price_Below_Range",
  Price_Above_Range = "Price_Above_Range",
  Price_Not_Available = "Price_Not_Available"
}
